
import React, { useEffect, useState } from 'react'
import noop from 'lodash/noop'
import Login from '../../../components/global/login'
import BookingHistory from '../bookingHistory/BookingHistory'
// import LinkAndUnlink from '../linkAndUnlink/LinkAndUnlink'
import { TabContent } from 'reactstrap'
import PaymentSetting from '../paymentSetting/PaymentSetting'
import PermitAccount from '../permitAccount/PermitAccount'
import VehicleAndPermit from '../vehicleAndPermit/VehicleAndPermit'
import Invoice from '../Invoice/Invoice'
import VehicleDetails from '../vehicleDetails'
import { useNavigate } from 'react-router-dom'
import URL from '../../../constants/urls'
import { EMPTY_ARRAY, EMPTY_OBJECT, tabIconPerTabName } from '../../../constants/globalConstants'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Passlist from '../passList/passlist'
import SearchTicket from '../eTicketRecipt/searchTicket'
import { sortPortalPermissionByKey } from '../../../utils/helper'
import { getUserProfile } from '../../../redux/actions/login'
import PermitRequest from '../permitRequest/PermitRequest'
import UserProfile from '../profile/UserProfile'
import { Circles } from 'react-loader-spinner'

function VehicleDemo(props) {
  const { dispatch, isAuthenticated, userData, permitData, notify, loader, partnerDetails } = props
  const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Account Menu')
  // FOR THE VEHICLE COUNT IN TH EFRONT UI 
  const navigate = useNavigate()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [userDetails, setuserDetails] = useState({})
  const [vehicleCount, setVehicleCount] = useState(false)
  const partner = window.location.toString().split('/')[3]
  const isMasquerade = localStorage.getItem('masquerade')
  // FOR TABS CHANGE 

  const [activeTab, setActiveTab] = useState(0)
  const [activeComp, setActiveComp] = useState('Profile')
  const [isLoader, setIsLoader] = useState(true)



  useEffect(() => {
    dispatch(getUserProfile()).then((res) => {
      if (res) {
        const userProfileData = JSON.parse(localStorage.getItem('userData'))
        userProfileData.user = res
        if (userProfileData) {
          localStorage.setItem('userData', JSON.stringify(userProfileData))
        } else {
          localStorage.setItem('userData', '{}')
        }
        setuserDetails(res)
        firstTimeOpenedTab(res)
      } else {
        firstTimeOpenedTab(userDetails)
      }
       setIsLoader(false)
    }).catch(() => {
      setIsLoader(false)
    })
  }, [EMPTY_ARRAY])

  const firstTimeOpenedTab = () => {
    const isReceipt = localStorage.getItem('isreceipt')
    // const firstComp = getAccessPermissionData?.[0]?.display_name
    const firstComp = 'Profile'
    if (isMasquerade) {
      // setActiveTab((res?.permit_count > 0) ? 0 : 5)
      // setActiveComp(res?.permit_count > 0 ? 'Permit Account' : 'Booking History')
      setActiveTab(0)
      setActiveComp('Profile')
    } else if (isReceipt && isReceipt != '') {
      let index = getAccessPermissionData?.findIndex(x => x.display_name == 'Receipts')
      if (index > 0) {
        setActiveTab(index + 1)
        setActiveComp('Receipts')
      } else {
        setActiveTab(0)
        setActiveComp(firstComp)
      }
    } else {
      setActiveTab(0)
      setActiveComp(firstComp)
    }
  }

  // const firstTimeOpenedTab = (res = {}) => {
  //   const isReceipt = localStorage.getItem('isreceipt')
  //   const firstComp = getAccessPermissionData?.[0]?.display_name
  //   if (isMasquerade) {
  //     setActiveTab((res?.permit_count > 0) ? 0 : 5)
  //     setActiveComp(res?.permit_count > 0 ? 'Permit Account' : 'Booking History')
  //   } else if (isReceipt && isReceipt != '') {
  //     let index = getAccessPermissionData?.findIndex(x => x.display_name == 'Receipts')
  //     if (index > 0) {
  //       setActiveTab(index)
  //       setActiveComp('Receipts')
  //     } else {
  //       setActiveTab(0)
  //       setActiveComp(firstComp)
  //     }
  //   } else {
  //     setActiveTab(0)
  //     setActiveComp(firstComp)
  //   }
  // }

  useEffect(() => {
    const permitDetails = permitData?.data
    const userDetailsPermit = permitDetails?.userDetails
    if (isAuthenticated) {
      setIsLoggedIn(true)
      const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
      const userDetails = getuserDatafromLocal?.user
      if (getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token != '') {
        setuserDetails(userDetails)
      } else {
        const userDetails = userData?.data?.user
        setuserDetails(userDetails)
      }
    } else if (userDetailsPermit?.access_token && userDetailsPermit?.access_token != '') {
      setIsLoggedIn(true)
      setuserDetails(userDetailsPermit?.user)
    } else {
      const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
      const userDetails = getuserDatafromLocal?.user
      if (getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token != '') {
        setuserDetails(userDetails)
        setIsLoggedIn(true)
      } else {
        setIsLoggedIn(false)

        navigate(`/${partner}${URL?.BASE_HOME}`)

      }
    }
  }, [EMPTY_ARRAY, isAuthenticated, permitData])


  // FOR THE TABS CHANGE 

  const handleLinkClick = (e, value) => {
    localStorage.removeItem('isreceipt')
    setActiveComp(e)
    setActiveTab(value)
  }


  const renderComponent = () => {
    switch (activeComp) {
      case 'Profile':
        return <UserProfile partnerDetails={partnerDetails} notify={notify} />
      case 'Permit Account':
        return <PermitAccount notify={notify} />
      case 'Permit Requests':
        return <PermitRequest notify={notify} />
      case 'Booking History':
        return <BookingHistory notify={notify} partnerDetails={partnerDetails} />
      case 'Payment Settings':
        return <PaymentSetting notify={notify} />
      case 'Vehicle Details':
        return <VehicleDetails partnerDetails={partnerDetails} notify={notify} setVehicleCount={setVehicleCount} vehicleCount={vehicleCount} />
      case 'Pass List':
        return <Passlist notify={notify} partnerDetails={partnerDetails} />
      case 'Receipts':
        return <SearchTicket notify={notify} />
      case 'Invoice':
        return <Invoice partnerDetails={partnerDetails} notify={notify} />

      default:
        break
    }
  }

  // console.log('activeTab',activeTab)

  return (
    <div className='min-height-600 mt-5'>
      {/* main section ---  */}
      <main>
        <section className="formDesign ">
          {/* for the maain header--- */}
          <VehicleAndPermit partner={partner} vehicleCount={vehicleCount} userDetails={userDetails} />
          <div className="container">
             {isLoader ? <span className='ms-2 d-flex justify-content-center'><Circles
                height="50"
                width="50"
                color="var(--bs-primary)"
                ariaLabel="circles-loading"
                visible={true}
            /></span> :
            <div className="row">
              <div className="col-sm-2 mb-3 col-12" style={{ minWidth: '15em' }} role="tablist" aria-orientation="vertical">
                <div className="list-group">
                  <button
                    className={`list-group-item list-group-item-action ${activeTab == '0' ? 'active' : ''}`}
                    type='button'
                    onClick={() => handleLinkClick('Profile', '0')}>
                    <i className='fa fa-user me-3'></i>
                    Profile
                  </button>
                  {getAccessPermissionData?.map((tabNameItem, tabNameIndex) => {
                    return (
                      <button
                        key={tabNameIndex + 1}
                        className={`list-group-item list-group-item-action ${activeTab === tabNameIndex + 1 ? 'active' : ''}`}
                        type="button"
                        onClick={() => handleLinkClick(tabNameItem?.display_name, tabNameIndex + 1)}>
                        <i className={`fa fa-${tabIconPerTabName(tabNameItem?.display_name)} me-3`}></i>
                        {tabNameItem?.display_name}
                      </button>
                    )
                  })}
                </div>
              </div>

              <div className="col-12 mb-3 col-sm">
                <div className="p-4 card">
                  <TabContent activeTab={activeTab}>
                    {renderComponent()}
                  </TabContent>

                </div>
              </div>
            </div>}
          </div>
        </section>
      </main>
      {/* login */}
      < Login setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn} userDetails={userDetails} />
      {loader && <div
        className='top-0 justify-content-center position-fixed w-100 h-100 zIndexSuperHigh bg-black d-flex opacity text-center opacity-25 text-white' >
        <div className='d-flex align-items-center justify-content-center h-100'><i className='fa fa-spinner fa-spin'></i></div>
      </div>}
    </div>
  )
}

VehicleDemo.propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  userData: PropTypes.object,
  permitData: PropTypes.object,
  notify: PropTypes.func,
  loader: PropTypes.bool,
  partnerDetails: PropTypes.object
}

VehicleDemo.defaulProps = {
  dispatch: noop,
  isAuthenticated: false,
  userData: EMPTY_OBJECT,
  permitData: EMPTY_OBJECT,
  notify: noop,
  loader: false,
  partnerDetails: EMPTY_ARRAY
}

function mapStateToProps({ login, paymentReducer, userDetailsReducer }) {
  return {
    isAuthenticated: login?.isAuthenticated,
    userData: login?.data,
    permitData: paymentReducer?.data,
    loader: userDetailsReducer?.loaderDownload
  }
}
export default connect(mapStateToProps)(VehicleDemo)